/* eslint-disable no-unused-vars */
import Cookie from 'js-cookie';
import history from 'setup/history';
import { req } from 'react-reqq-lite';
import { closeModal } from 'partial/components/Modal';
import { toastSuccess } from 'react-geek-toast';
import { authRedirect, storage } from 'helper';
import { getUserTypeFromToken, transformPermissions } from './transformers';
import { showAuthOtpModal } from './modals/OtpModal';
import * as c from './constants';

export const login = (payload) => {
  req.post({
    key: c.LOGIN,
    url: '/api/v1/auth/login/administrator',
    payload,
    onSuccess: (res) => {
      console.log("+res?.response?.is_otp_2fa_enabled", res.response.is_otp_2fa_enabled)
      const authSuccess = (response) => {
        const token = response?.data?.access_token;
        const loginProfile = response?.data;
        Cookie.set('_token', token);
        
        // Fetch profile with permissions
        req.get({
          key: 'PROFILE_FETCH',
          url: '/api/v1/mng/my/profile',
          onSuccess: (profileRes) => {
            const profile = profileRes?.response?.data;
            // Extract permissions from profile response
            const permissions = (profile?.permissions || []).map((p) => p.code);
            Cookie.set('_permissions', permissions);
            storage.set('_profile', profile);
            req.set(c.AUTHENTICATION, {
              isAuthenticated: true,
              userType: getUserTypeFromToken(token),
            });
            req.set(c.PROFILE, profile);
            history.push(authRedirect());
            toastSuccess('Successfully logged in!');
          },
          onError: (err) => {
            // Fallback to login response if profile fetch fails
            const permissions = transformPermissions(loginProfile?.roles || []);
            Cookie.set('_permissions', permissions);
            storage.set('_profile', loginProfile);
            req.set(c.AUTHENTICATION, {
              isAuthenticated: true,
              userType: getUserTypeFromToken(token),
            });
            req.set(c.PROFILE, loginProfile);
            history.push(authRedirect());
            toastSuccess('Successfully logged in!');
          },
        });
      };
      if (res.response.is_otp_2fa_enabled === 1) {
        showAuthOtpModal(payload, (res2) => {
          authSuccess(res2?.response);
        });
        return;
      }

      // if (true) return;
      authSuccess(res?.response);
    },
  });
};

export const logout = (onSuccess) => {
  req.post({
    key: c.LOGOUT,
    url: '/api/v1/mng/logout',
    onSuccess: () => {
      Cookie.remove('_token');
      Cookie.remove('_permissions');
      storage.remove('_profile');
      closeModal();
      req.set(c.AUTHENTICATION, {
        isAuthenticated: false,
        userType: null,
      });
      toastSuccess('You Successfully log out.');
      if (onSuccess) onSuccess();
    },
    onError: (err) => {
      if (
        err?.status === 403 ||
        err?.status === 500 ||
        err?.response?.message === 'token_expired' ||
        err?.response?.message === 'unauthorized' ||
        err?.response?.message === 'Token expired.' ||
        err?.response?.message === 'Token Expired.' ||
        err?.response?.message === 'Token expired' ||
        err?.response?.message === 'Invalid token.'
      ) {
        Cookie.remove('_token');
        Cookie.remove('_permissions');
        storage.remove('_profile');
        closeModal();
        req.set(c.AUTHENTICATION, {
          isAuthenticated: false,
          userType: null,
        });
        history.push('/');
        toastSuccess('You Successfully log out.');
      }
    },
  });
};

export const forgotPassword = (payload, onSuccess) => {
  req.post({
    key: c.FORGOT_PASSWORD,
    url: '/api/admin/forgot_password',
    payload,
    onSuccess: () => {
      onSuccess();
      toastSuccess(
        'Please check your email to proceed with the reset password process.'
      );
    },
  });
};

export const resetPassword = (payload, onSuccess) => {
  req.post({
    key: c.RESET_PASSWORD,
    url: '/api/admin/reset_password',
    payload,
    onSuccess: () => {
      onSuccess();
      toastSuccess('Successfully reset password!');
    },
  });
};

export const changePassword = (payload, onSuccess) => {
  req.put({
    key: c.CHANGE_PASSWORD,
    url: '/api/admin/profile/update_password',
    payload,
    onSuccess: () => {
      onSuccess();
      toastSuccess('Successfully changed password!');
    },
  });
};

export const setPassword = (payload, onSuccess) => {
  req.post({
    key: c.SET_PASSWORD,
    url: '/api/v1/pub/reset-password',
    payload,
    onSuccess: () => {
      onSuccess();
      toastSuccess('Successfully set password!');
    },
  });
};